import { Backend } from '@/_axios';

export default {
  SAVE_AS_TEMPLATE: function ({ commit }, id) {
    Backend.post('/api/save_as_template', { id: id }).then((response) => {
      commit('SAVE_AS_TEMPLATE', response.data.data);
    }, (err) => {
      commit('ERROR_SAVE_AS_TEMPLATE');
    });
  },
  GET_TEMPLATES_LIST: function ({ commit }, { search_value, pageNumber, pageSize }) {
    Backend.get('/api/all_templates', { params: { search_value: search_value, pageNumber: pageNumber, pageSize: pageSize } }).then((response) => {
      commit('SET_TEMPLATES', response.data.data);
    }, (err) => {
      console.log(err);
    });
  },
  TEMPLATES_DROPDOWN: function ({ commit }) {
    Backend.get('/api/templates_dropdown').then((response) => {
      commit('SET_TEMPLATES_DROPDOWN', response.data.data);
    }, (err) => {
      console.log(err);
    });
  },
  DELETE_TEMPLATE: function ({ commit }, id) {
    Backend.post('/api/delete_template', { id: id }).then((response) => {
      commit({ type: 'DELETE_TEMPLATE', id: id, message: response.data.data.message });
    }, (err) => {
      commit({ type: 'ERROR_DELETE_TEMPLATE', id: id, message: err.response.data.data.message });
      console.log(err);
    });
  },
  SAVE_TEMPLATE: function ({ commit }, data) {
    return Backend.post('/api/save_template', { data: data });
  },
  COPY_TEMPLATE: function ({ commit }, id) {
    Backend.post('/api/copy_template', { id: id }).then((response) => {
      commit({ type: 'ADD_TEMPLATE', data: response.data.data });
    }, (err) => {
      commit({ type: 'ERROR_COPY_TEMPLATE', message: err.response.data.data.message });
    });
  },
  UPDATE_TEMPLATE: function ({ commit }, data) {
    return Backend.post('/api/update_template', { data: data });
  },
  DELETE_TEMPLATE_VARIABLE: function ({ commit }, id) {
    Backend.post('/api/delete_template_variable', { id: id }).then((response) => {

    }, (err) => {
      console.log(err);
    });
  },
  DELETE_TEMPLATE_CALCULATION_ROW: function ({ commit }, id) {
    Backend.post('/api/delete_template_calculation_row', { id: id }).then((response) => {

    }, (err) => {
      console.log(err);
    });
  }
};
